<template>
  <section>
    <div class="md:flex justify-between">
      <label class="block">
        <!-- class="form-select block w-full mt-1" -->
        <select
          class="w-full h-10 pl-3 pr-6 text-base placeholder-gray-600 rounded-lg appearance-none focus:outline-none ring-1 ring-gray-darkest"
          :value="value"
          @input="$emit('input', $event.target.value)"
        >
          <option value="">Select Date</option>
          <option value="1">1</option>
        </select>
      </label>
      <label class="block">
        <select
          class="w-full h-10 pl-3 pr-6 text-base placeholder-gray-600 rounded-lg appearance-none focus:outline-none ring-1 ring-gray-darkest"
        >
          <option value="">Select Month</option>
          <option value="1">January</option>
        </select>
      </label>
      <label class="block">
        <select
          class="w-full h-10 pl-3 pr-6 text-base placeholder-gray-600 rounded-lg appearance-none focus:outline-none ring-1 ring-gray-darkest"
        >
          <option value="">Select Year</option>
          <option value="2000">2000</option>
        </select>
      </label>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    value: String,
  },
  data() {
    return {};
  },
};
</script>